module.exports = __webpack_public_path__ + "media/images/redesign-images/corporate/business/bus-product-2-0e7649bd2175c1d7f6e8c4ec53636a5c.jpg";